<div class="title">Ce lien n'est malheureusement pas valide...</div>

<p>Il est possible que ce lien vous ait été transmis via un bouton dans un email, et soit expiré.
  Les invitations pour créer un compte sont valides 30 jours et d’autres demandes spécifiques sont désactivées plus rapidement.
  Vérifiez votre email afin de comprendre la cause, et répondez à l’expéditeur pour qu’il vous en transmette un nouveau.</p>
